import api from '../api';

export const updateJob = async (jobId, data) => {
    const res = await api.patch(`/job/updateJob/${jobId}`, data);
    return res.data;
}
